import{styled as o}from"@mui/joy";import r from"@mui/joy/ButtonGroup";var t=o(r)`
  border-radius: ${({theme:o})=>o.spacing(1)};
  overflow: hidden;
`;export{t as BaseButtonGroup};
//# sourceMappingURL=BaseButtonGroup.js.map